import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function StandortSelect({
  id,
  value,
  standorte,
  onChange,
}: {
  id?: string;
  value?: string;
  standorte: string[];
  onChange: (standort: string) => void;
}) {
  const { t } = useTranslation();

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id={id}>
        <SelectValue
          placeholder={t('domain.datev.abgleich.zuordnung.auswaehlen')}
        />
      </SelectTrigger>
      <SelectContent mobileTitle={t('domain.datev.abgleich.spalten.standort')}>
        {standorte.map((standort) => (
          <SelectItem key={standort} value={standort}>
            {standort}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
